import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { getAdminStats } from "../../services/adminService";

const AdminDashboardPage = () => {
	const { profile } = useAuth();

	const [stats, setStats] = useState([
		{ title: "Commandes du jour", value: "..." },
		{ title: "Chiffre d’affaires", value: "..." },
		{ title: "Produits actifs", value: "..." },
		{ title: "Clients inscrits", value: "..." },
	]);

	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const loadStats = async () => {
			try {
				const data = await getAdminStats();

				setStats([
					{
						title: "Commandes du jour",
						value: data.ordersToday ?? 0,
					},
					{
						title: "Chiffre d’affaires",
						value: `${Number(data.revenue || 0).toLocaleString("fr-CH", { style: "currency", currency: "CHF" })}`,
					},
					{
						title: "Produits actifs",
						value: data.activeProducts ?? 0,
					},
					{
						title: "Clients inscrits",
						value: data.usersCount ?? 0,
					},
				]);
			} catch (error) {
				console.error(
					"Erreur chargement dashboard admin:",
					error?.message || error,
				);
			} finally {
				setLoading(false);
			}
		};

		loadStats();
	}, []);

	const quickLinks = [
		{ label: "Voir les commandes", to: "/admin/orders" },
		{ label: "Gérer les produits", to: "/admin/products" },
		{ label: "Ajouter un produit", to: "/admin/products/new" },
		{ label: "Gérer les utilisateurs", to: "/admin/users" },
		{ label: "Paramètres", to: "/admin/settings" },
		{ label: "Gérer les réservations", to: "/admin/reservations" },
		{ label: "Gérer la newsletter", to: "/admin/newsletter" },
	];

	return (
		<div className="max-w-7xl mx-auto px-4 pt-32 pb-10">
			<div className="mb-8">
				<h1 className="text-3xl font-bold text-[#2A2A2A]">Dashboard Admin</h1>
				<p className="text-[#6B6B6B] mt-2">
					Bienvenue {profile?.first_name || "Admin"}, voici un aperçu de la
					boutique.
				</p>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-10">
				{stats.map((stat) => (
					<div
						key={stat.title}
						className="bg-white border border-[#E6E1D6] rounded-2xl p-5 shadow-sm"
					>
						<p className="text-sm text-[#6B6B6B]">{stat.title}</p>
						<p className="text-2xl font-bold text-[#2A2A2A] mt-2">
							{loading ? "..." : stat.value}
						</p>
					</div>
				))}
			</div>

			<div className="bg-white border border-[#E6E1D6] rounded-2xl p-6 shadow-sm">
				<h2 className="text-xl font-semibold text-[#2A2A2A] mb-4">
					Accès rapides
				</h2>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
					{quickLinks.map((link) => (
						<Link
							key={link.to}
							to={link.to}
							className="block rounded-xl border border-[#E6E1D6] p-4 hover:bg-[#FFFCF8] transition"
						>
							<span className="font-medium text-[#2A2A2A]">{link.label}</span>
						</Link>
					))}
				</div>
			</div>
		</div>
	);
};

export default AdminDashboardPage;
